import * as types from '../types';
import JWT from '../modules/getjwtdata';
import store from '../modules/store';

// The auth reducer. The starting state sets authentication
// based on a token being in local storage. In a real app,
// we would also want a util to check if the token is expired.
function auth(state = {
  isFetching: false,
  isFetchingPassword: false,
  isAuthenticated: localStorage.getItem('token') ? JWT.verify(localStorage.getItem('token')) : false,
  user: localStorage.getItem('token') ? JWT.decode(localStorage.getItem('token')) : {},
  localData: localStorage.getItem('token') ? store.get(JWT.decode(localStorage.getItem('token')).id) : {},
  rememberUser: localStorage.getItem('token'),
  errors: [],
  passwordEmail: {
    isFetching: false,
    hasFetched: false,
    isSuccess: false,
    errors: [],
  },
  passwordReset: {
    isFetching: false,
    hasFetched: false,
    isSuccess: false,
    errors: [],
  },
}, action) {
  switch (action.type) {
  case types.LOGIN_REQUEST:
    return { ...state,
        isFetching: true,
        isAuthenticated: false,
        user: {},
        errors: [],
      };
  case types.LOGIN_SUCCESS:;
    return { ...state,
        isFetching: false,
        isAuthenticated: true,
        user: action.user,
        localData: action.localData,
        errors: [],
      };
  case types.LOGIN_REFRESH:
    return { ...state,
        isFetching: false,
        isAuthenticated: true,
        user: action.user,
        errors: [],
      };
  case types.HAS_LOGGED_IN:
   store.set(state.user.id, {...state.localData, hasLoggedIn: action.hasLoggedIn});
    return { ...state,
        localData: {...state.localData, hasLoggedIn: action.hasLoggedIn}
  };

  case types.LOGIN_FAILURE:
    return { ...state,
        isFetching: false,
        isAuthenticated: false,
        user: {},
        errors: action.errors,
      };

  case types.LOGOUT_REQUEST:
    return { ...state,
        isFetching: true,
      };

  case types.LOGOUT_SUCCESS:
    return { ...state,
        isFetching: false,
        isAuthenticated: false,
        user: {},
      };

  case types.LOGOUT_FAILURE:
    return { ...state,
        isFetching: false,
        errors: action.errors,
      };

  case types.PASSWORD_EMAIL_REQUEST:
    return { ...state,
        passwordEmail: {
          isFetching: true,
          hasFetched: false,
          isSuccess: false,
          errors: [],
        },
      };

  case types.PASSWORD_EMAIL_SUCCESS:
    return { ...state,
        passwordEmail: {
          isFetching: false,
          hasFetched: true,
          isSuccess: true,
          errors: [],
        },
      };

  case types.PASSWORD_EMAIL_FAILURE:
    return { ...state,
        passwordEmail: {
          isFetching: false,
          hasFetched: true,
          isSuccess: false,
          errors: action.errors,
        },
      };

  case types.PASSWORD_RESET_REQUEST:
    return { ...state,
        passwordReset: {
          isFetching: true,
          hasFetched: false,
          isSuccess: false,
        },
      };

  case types.PASSWORD_RESET_SUCCESS:
    return { ...state,
        passwordReset: {
          isFetching: false,
          hasFetched: true,
          isSuccess: true,
        },
      };

  case types.PASSWORD_RESET_FAILURE:
    return { ...state,
        passwordReset: {
          isFetching: false,
          hasFetched: true,
          isSuccess: false,
          errors: action.errors,
        },
      };

  case types.CHANGE_SETTINGS_REQUEST:
    return { ...state,
        isFetching: true,
        errors: []
      };

  case types.CHANGE_SETTINGS_SUCCESS:
    return { ...state,
        isFetching: false,
        errors: [],
      };

  case types.CHANGE_SETTINGS_FAILURE:
  console.log(action);
    return { ...state,
        isFetching: false,
        errors: action.errors,
      };

  case types.CHANGE_PASSWORD_REQUEST:
    return { ...state,
        isFetchingPassword: true,
        errors: [],
      };

  case types.CHANGE_PASSWORD_SUCCESS:
    return { ...state,
        isFetchingPassword: false,
        errors: [],
      };

  case types.CHANGE_PASSWORD_FAILURE:
    return { ...state,
        isFetchingPassword: false,
        errors: action.errors,
      };

  default:
    return state;
  }
}

export default auth;



// WEBPACK FOOTER //
// ./src/reducers/auth.js